import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { SITE } from '@/app/constants';
import type { AgentVoiceLanguageType, AgentVoiceOption } from '@/app/types';
import { VOICE_AUTO_IMAGE } from '../constants';

const CN_LANGUAGE_LIST: AgentVoiceLanguageType[] = [
  'all',
  'zh',
  'en',
  'ja',
  'ko',
  'es',
  'pt',
  'fr',
  'id',
  'de',
  'it',
  'vi',
  'th',
  'fi',
  'nl',
  'hi',
  'ar',
  'tr',
  'uk',
  'pl',
  'ro',
  'el',
  'cs',
  'ru',
];

const EN_LANGUAGE_LIST: AgentVoiceLanguageType[] = [
  'all',
  'en',
  'es',
  'fr',
  'zh',
  'ja',
  'pt',
  'de',
  'id',
  'ko',
  'it',
  'vi',
  'th',
  'fi',
  'nl',
  'hi',
  'ar',
  'tr',
  'uk',
  'pl',
  'ro',
  'el',
  'cs',
  'ru',
];

// 根据当前语言环境选择对应的排序列表
const LANGUAGE_LIST = SITE === 'china' ? CN_LANGUAGE_LIST : EN_LANGUAGE_LIST;

export const useGetVoiceLanguage = (): {
  list: { name: string; id: AgentVoiceLanguageType }[];
  autoAudioItem: AgentVoiceOption;
  getLanguageName: (language: AgentVoiceLanguageType) => string;
} => {
  const t = useTranslations();

  // 按照排序列表的顺序对 baseList 进行排序
  const list = useMemo(() => {
    return LANGUAGE_LIST.map((language) => {
      return {
        name: t(`agentProject.voiceLanguage.${language}`),
        id: language,
      };
    });
  }, []);

  const getLanguageName = (language: AgentVoiceLanguageType) => {
    return list.find((item) => item.id === language)?.name || '';
  };

  const autoAudioItem = useMemo<AgentVoiceOption>(
    () => ({
      id: 'auto',
      name: t('agentProject.voiceSelect.auto'),
      description: t('agentProject.voiceSelect.autoTooltip'),
      img: VOICE_AUTO_IMAGE,
      language: 'all',
    }),
    [t],
  );

  return {
    list,
    autoAudioItem,
    getLanguageName,
  };
};
